export default "__VITE_ASSET__Bwkv1Naz__"